export default "__VITE_ASSET__3Krz8K54__"